/**
 * Karty, ktoré má v balíčku viac postáv. Text je na nich rovnaký, tak nech je
 * rovnaká aj implementácia — registruje ich potom každá postava pod svojím ID.
 */

import { drawCard } from '../ops.js';
import { askChoice } from '../ops.js';
import { askMove, emptySpacesInZone } from './helpers.js';
import type { CardEffect, EffectCtx } from './types.js';

/** „Cancel all effects on your opponent's card." */
export const feint: CardEffect = { cancelsOpponent: true };

/** „Draw 1 card. If you won the combat, draw 2 cards instead." */
export const regroup: CardEffect = {
  after: (e) => {
    const count = e.won ? 2 : 1;
    for (let i = 0; i < count; i++) drawCard(e.ctx, e.player);
  },
};

/** „If your fighter started this turn in a different space, this card's value is 5 instead." */
export const momentousShift: CardEffect = {
  during: (e, value) => (startedElsewhere(e) ? 5 : value),
};

function startedElsewhere(e: EffectCtx): boolean {
  if (!e.fighterId) return false;
  const fighter = e.ctx.state.fighters.find((f) => f.id === e.fighterId);
  const start = e.ctx.state.turn.startSpaces[e.fighterId];
  return Boolean(fighter && start && start !== fighter.spaceId);
}

/** „Draw N cards." */
export function draw(count: number): CardEffect {
  return {
    after: (e) => {
      for (let i = 0; i < count; i++) drawCard(e.ctx, e.player);
    },
  };
}

/**
 * „If you won the combat, choose one of the fighters in the combat and move
 * them up to N spaces." Vyberá majiteľ karty — aj keď posunie súperovu figúrku.
 */
export function skirmish(max: number): CardEffect {
  return {
    after: (e) => {
      if (!e.won) return;
      const inCombat = [e.fighterId, e.opponentFighterId].filter((id): id is string => Boolean(id));
      askMove(e, {
        fighters: inCombat,
        max,
        label: `Presuň jednu figúrku zo súboja až o ${max} priestory`,
      });
    },
  };
}

/** „Choose an empty space in this fighter's zone. Place this fighter in that space." */
export const disengage: CardEffect = {
  after: (e) => {
    if (!e.fighterId) return;
    const spaces = emptySpacesInZone(e.ctx, e.fighterId);
    if (spaces.length === 0) return;
    askChoice(e.ctx, {
      kind: 'place',
      player: e.player,
      source: e.cardId,
      label: 'Polož figúrku na prázdny priestor v jej zóne',
      optional: false,
      fighterId: e.fighterId,
      spaces,
    });
  },
};
